export default __webpack_public_path__ + "static/media/exhibition.a3e1b184.png";